import React from 'react';
import { Box, Text, Flex, Space } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { useOrgStore } from '@Models/useOrgModel';
import { MemoTextLabel } from '@Report/MemoTextLabel';
import MenuWithLabel from '@Components/Common/Menu';
import { RoleTarget } from '@Types/administrator';
import EditRoleAssigment from './EditRoleAssigment';
import AddRoleAssigment from './AddRoleAssigment';

const RoleAssignment = React.memo(
  ({
    isEdit,
    roleTargets,
    setCheckTargets,
  }: {
    isEdit: boolean;
    roleTargets: RoleTarget[] | null;
    setCheckTargets: (checkedKeys: RoleTarget[]) => void;
  }) => {
    const { t } = useTranslation();
    const { orgs, defaultSingleOrgId } = useOrgStore();
    const [currentOrgId, setCurrentOrgId] = React.useState(defaultSingleOrgId);
    const handleClick = (event: any) => {
      const key = event.target.getAttribute('value');
      setCurrentOrgId(key);
    };

    return (
      <Box mb={48} width="100%" overflowY="auto">
        <Text mt="12px">{t('administration.rbac.assigment.desc')}</Text>
        <Flex flexDirection="column" mt={24}>
          <Flex flexDirection="row">
            <Box>
              <MemoTextLabel label={'reportCommon.labels.organization'} />
              <Space mr={22} />
              <MenuWithLabel
                menuItems={orgs?.filter((x) => x.key !== 'all') || []}
                minWidth={287}
                selectedKey={currentOrgId || ''}
                onClick={handleClick}
              />
            </Box>
          </Flex>
          <Box>
            {isEdit ? (
              <EditRoleAssigment
                currentOrgId={currentOrgId}
                roleTargets={roleTargets}
                setCheckTargets={setCheckTargets}
              />
            ) : (
              <AddRoleAssigment
                currentOrgId={currentOrgId}
                setCheckTargets={setCheckTargets}
              />
            )}
          </Box>
        </Flex>
      </Box>
    );
  }
);

export default RoleAssignment;
